import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    id: String,
    enabled: Boolean
  }

  connect() {
    this.scriptId = "google-analytics-script"
    this.boundTrackPageView = () => this.trackPageView()
    this.boundConsentChanged = () => this.applyConsent()

    document.addEventListener('turbo:load', this.boundTrackPageView)
    window.addEventListener("cookie-consent:changed", this.boundConsentChanged)
    this.applyConsent()
  }

  disconnect() {
    document.removeEventListener('turbo:load', this.boundTrackPageView)
    window.removeEventListener("cookie-consent:changed", this.boundConsentChanged)
  }

  applyConsent() {
    if (this.analyticsAllowed) {
      this.enableAnalytics()
    } else {
      this.disableAnalytics()
    }
  }

  trackPageView() {
    if (this.analyticsAllowed && typeof gtag !== 'undefined' && this.idValue) {
      gtag('config', this.idValue, {
        page_path: window.location.pathname + window.location.search
      })
    }
  }

  enableAnalytics() {
    if (!this.enabledValue || !this.idValue || document.getElementById(this.scriptId)) return

    window.dataLayer = window.dataLayer || []
    window.gtag = function gtag() {
      window.dataLayer.push(arguments)
    }

    const script = document.createElement("script")
    script.id = this.scriptId
    script.async = true
    script.src = `https://www.googletagmanager.com/gtag/js?id=${this.idValue}`
    script.addEventListener("load", () => {
      window.gtag('js', new Date())
      this.trackPageView()
    })
    document.head.appendChild(script)
  }

  disableAnalytics() {
    if (this.analyticsAllowed) return

    document.getElementById(this.scriptId)?.remove()
    this.clearGoogleAnalyticsCookies()
  }

  clearGoogleAnalyticsCookies() {
    const cookieNames = document.cookie
      .split(";")
      .map((cookie) => cookie.trim().split("=")[0])
      .filter((name) => name === "_ga" || name === "_gid" || name === "_gat" || name.startsWith("_ga_"))

    cookieNames.forEach((name) => this.expireCookie(name))
  }

  expireCookie(name) {
    const expires = "Thu, 01 Jan 1970 00:00:00 GMT"
    const base = `${name}=; expires=${expires}; path=/; SameSite=Lax`

    document.cookie = base
    this.cookieDomains.forEach((domain) => {
      document.cookie = `${base}; domain=${domain}`
    })
  }

  get analyticsAllowed() {
    try {
      return JSON.parse(localStorage.getItem("cookie_preferences"))?.analytics === true
    } catch {
      return false
    }
  }

  get cookieDomains() {
    const host = window.location.hostname
    const parts = host.split(".")
    const domains = [host]

    if (parts.length > 2) {
      domains.push(`.${parts.slice(-2).join(".")}`)
    }

    return [...new Set(domains)]
  }
}
